module.exports = __webpack_public_path__ + "static/img/map6.8b6c388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map6.jpg
// module id = BEsd
// module chunks = 1